import { proxy } from 'valtio';

const intervalsOptions = [
    { value: 1, label: 'Месяц' },
    { value: 2, label: 'Квартал' },
    { value: 3, label: 'Полугодие' },
    { value: 4, label: 'Год' },
];

export const store = proxy({
    activeIntervalId: intervalsOptions[0].value,
    options: intervalsOptions,
});

export const actions = {
    setActiveIntervalId(intervalId) {
        store.activeIntervalId = intervalId;
    },

    getParams() {
        return {
            intervalId: store.activeIntervalId,
        };
    },
};
